import React from 'react';
import * as Bixby from '$/core';
import ClientHelpCenterBase from '$/pages/client/help-center/help-center-base';

const ClientVideoTutorials: React.FC = () => {
  return <ClientHelpCenterBase type={Bixby.Enums.HelpCenterItemType.Video} />;
};

export default ClientVideoTutorials;
